import { useEffect, useState } from "react";
import { ShieldAlert, ExternalLink, Bell } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { getAdminPresaves } from "@/lib/afmApi";
import { fmtNum } from "@/lib/format";
import { Loading, SectionTitle } from "@/components/common";

export default function AdminPresaves() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("loading");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    getAdminPresaves(user.id)
      .then((d) => { setItems(Array.isArray(d) ? d : (d?.presaves || [])); setStatus("ok"); })
      .catch((e) => { setMsg(e?.response?.data?.detail || "Acceso restringido"); setStatus("denied"); });
  }, [user.id]);

  if (status === "loading") return <Loading />;

  if (status === "denied") {
    return (
      <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-white py-20 text-center" data-testid="admin-denied">
        <div className="mb-4 rounded-full border border-amber-300 bg-amber-50 p-4 text-amber-700"><ShieldAlert className="h-7 w-7" /></div>
        <h3 className="font-serif text-xl font-bold text-black">Solo administradores</h3>
        <p className="mt-2 max-w-sm text-sm text-slate-500">{msg}</p>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="admin-presaves-page">
      <SectionTitle>Todos los pre-saves</SectionTitle>
      <div className="rounded-xl border border-slate-200 bg-white">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-slate-50 text-left text-[11px] uppercase tracking-wider text-slate-500">
                <th className="px-5 py-3 font-semibold">Lanzamiento</th>
                <th className="px-5 py-3 font-semibold">Artista</th>
                <th className="px-5 py-3 text-right font-semibold">Pre-saves</th>
                <th className="px-5 py-3 text-center font-semibold">Link</th>
              </tr>
            </thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.id} className="border-t border-slate-100 hover:bg-slate-50">
                  <td className="px-5 py-3 font-medium text-slate-800">{p.title}</td>
                  <td className="px-5 py-3 text-slate-600">{p.artist_name || p.artist_id}</td>
                  <td className="px-5 py-3 text-right font-mono tabular-nums text-black"><span className="inline-flex items-center gap-1"><Bell className="h-3 w-3 text-slate-400" />{fmtNum(p.count)}</span></td>
                  <td className="px-5 py-3 text-center">
                    <a href={`/presave/${p.id}`} target="_blank" rel="noopener noreferrer" className="inline-flex text-slate-400 hover:text-black"><ExternalLink className="h-4 w-4" /></a>
                  </td>
                </tr>
              ))}
              {!items.length && <tr><td colSpan={4} className="px-5 py-10 text-center text-sm text-slate-400">No hay pre-saves registrados.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
